import { useState, useEffect } from 'react';

function getSize() {
  return [window.innerWidth, window.innerHeight];
}

function useWidowSize() {
  const [size, setSize] = useState(getSize());

  useEffect(() => {
    function resizeListener() {
      setSize(getSize());
    }
    window.addEventListener('resize', resizeListener);
    return () => {
      window.removeEventListener('resize', resizeListener);
    };
  }, []);

  return size;
}

export default useWidowSize;
